(ns practitest.frontend.components2.grid.row-menu
  (:require [reagent.core :as reagent]
            [practitest.frontend.common.dom :as dom]))

(defn row-menu [_ disabled-action-menu? menu-items]
  (let [local-state (reagent/atom {})]
    (fn [_ disabled-action-menu? menu-items]
      (let [show-dropdown? (reagent/cursor local-state [:show-dropdown?])
            hide-dropdown! #(reset! show-dropdown? false)
            toggle-dropdown! #(swap! show-dropdown? not)

            show-confirmation? (reagent/cursor local-state [:show-confirmation?])
            hide-confirmation! #(swap! local-state assoc :show-confirmation? false)
            show-confirmation! (fn [details]
                                 (swap! local-state assoc
                                        :confirmation-details details
                                        :show-confirmation? true))

            menu-items menu-items]
        [:div.action-menu-button
         {:class (dom/classes-pairs-v :disabled disabled-action-menu?)}
         [practitest.frontend.components.card-view/confirmation-dialog
          show-confirmation?
          (reagent/cursor local-state [:confirmation-details])]
         [practitest.frontend.components.card-view/dropdown-menu
          {:show?      show-dropdown?
           :toggle!    toggle-dropdown!
           :hide!      hide-dropdown!
           :disabled?  disabled-action-menu?
           :menu-items (for [item menu-items]
                         [practitest.frontend.components.card-view/menu-item
                          {:hide!              hide-dropdown!
                           :show-confirmation! show-confirmation!
                           :hide-confirmation! hide-confirmation!}
                          item])}]]))))
